
import { Component, Prop, Vue, } from 'vue-property-decorator';
import type { GlobalConfig, } from '~/utils/self-serve/global-config';

@Component
export default class UnauthedNav extends Vue {
	@Prop({
		type: String,
		required: true,
	})
	logo!: string;

	@Prop({
		type: [ Number, String, ],
		required: false,
	})
	logoWidth: number | string | undefined;

	@Prop({
		type: [ Number, String, ],
		required: false,
	})
	logoHeight: number | string | undefined;

	@Prop({
		type: Object,
		required: false,
	})
	logoDetails: GlobalConfig['SouthernWaterLogoDetails'];

	@Prop({ default: 'content', })
		contentAchor!: string;

	@Prop({
		default: true,
		required: false,
	})
	showSafeAndSecure!: boolean;
}
